export enum RequestStatus {
  pending = 'pending',
  in_process = 'in_process',
  accepted = 'accepted',
  rejected = 'rejected',
  disabled = 'disabled',
}

export const RequestStatusLabels: Record<RequestStatus, string> = {
  [RequestStatus.pending]: 'Pendiente',
  [RequestStatus.in_process]: 'En proceso',
  [RequestStatus.accepted]: 'Aceptado',
  [RequestStatus.rejected]: 'Rechazado',
  [RequestStatus.disabled]: 'Borrado',
};
